// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
  <sub-header header="'Create Invoice Booklets'" tab="true"></sub-header>

    <form name="\$ctrl.form">
      <table class="misc-transaction__table table table--generate-row-ids">
        <tbody>
        <tr>
          <td></td>
          <td>Start series</td>
          <td>
            <input
              required
              ng-model="\$ctrl.input.startNumber"
              type="number"
              min="1">
          </td>
        </tr>
        <tr>
          <td></td>
          <td>Number of booklets</td>
          <td>
            <input
              required
              ng-model="\$ctrl.input.bookletsCount"
              type="number"
              min="1"
              max="100">
          </td>
        </tr>
        </tbody>
      </table>
      <div class="buttons">
        <button
            class="btn btn-warning"
            ng-click="\$ctrl.redirectBack()">
          Cancel
        </button>
        <button
            class="btn btn-primary"
            command-access="CreateOfficialReceiptBooklets"
            ng-click="\$ctrl.create()"
            ng-disabled="\$ctrl.form.\$invalid">
          Create
        </button>
      </div>
    </form>
</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/official-receipt-booklet/create/official-receipt-booklet-create.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;